import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'span';
};
/** Tasteful scroll-reveal: fade + slide up, once. */
export function Reveal({
  children,
  delay = 0,
  y = 28,
  className = '',
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as] as typeof motion.div;
  return <MotionTag className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-187">
      {children}
    </MotionTag>;
}